import { createFeatureSelector } from "@ngrx/store";
import * as fromRouter from "@ngrx/router-store";
import { RouterStateUrl } from "@edp-utils/route-serializer";

export const getRouterStateES = createFeatureSelector<fromRouter.RouterReducerState<RouterStateUrl>>("router");
